import { AttributeBaseModel } from './AttributeBaseModel';
export class UInt256AttributeModel extends AttributeBaseModel {
    constructor({ usage, value }) {
        super();
        this.usage = usage;
        this.value = value;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeUInt256(this.value);
    }
}

//# sourceMappingURL=UInt256AttributeModel.js.map
